/** Shared constants for the Renovations view + its sub-components. */

export const PROJECT_STATUS = {
  planning: { label: 'Planning', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  in_progress: { label: 'In Progress', color: 'bg-amber-100 text-amber-700 border-amber-200' },
  on_hold: { label: 'On Hold', color: 'bg-slate-100 text-slate-700 border-slate-200' },
  completed: { label: 'Completed', color: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  cancelled: { label: 'Cancelled', color: 'bg-red-100 text-red-700 border-red-200' },
};

export const PROJECT_TYPES = [
  'Kitchen Remodel',
  'Bathroom Renovation',
  'Room Addition',
  'Roof Replacement',
  'HVAC Installation',
  'Flooring',
  'Exterior Paint',
  'Interior Paint',
  'Deck/Patio',
  'Pool Installation',
  'Landscaping Overhaul',
  'Foundation Repair',
  'Electrical Upgrade',
  'Plumbing Overhaul',
  'Window Replacement',
  'Other',
];

export const EMPTY_FORM = {
  property_id: '',
  title: '',
  project_type: '',
  description: '',
  contractor_name: '',
  contractor_phone: '',
  contractor_email: '',
  estimated_budget: '',
  actual_cost: '',
  start_date: '',
  estimated_end_date: '',
  actual_end_date: '',
  status: 'planning',
  progress_percent: 0,
  notes: '',
  permits_required: false,
  permit_status: '',
};
